import React, { useEffect, useState } from "react";
import "./login.scss";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { compose } from "redux";
import withApiService from "../hoc/with-api-service";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router";
import { signIn } from "../../store/actions/auth";
// import ForgotPassword from "./forgot-password";
import { Link } from "react-router-dom";

const Login = (props) => {
  const error = useSelector((state) => state.auth.errorLogin);
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // const [openForgot, setOpenForgot] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(signIn({ email, password }, props.doInit));
  };

  useEffect(() => {
    document.title = "Welcome | School Manager";
  }, []);

  /*  const openForgotForm = () => {
    setOpenForgot(!openForgot);
    setEmail("");
    setPassword("");
    dispatch(loginError(null));
  };*/

  /*  if (openForgot) {
    return (
      <div className="loginWrapper">
        <div className="login">
          <div className="loginContainer">
            <ForgotPassword
              open={openForgot}
              setOpen={setOpenForgot}
              error={error}
            />
          </div>
        </div>
      </div>
    );
  }*/

  return (
    <div className="loginWrapper">
      <div className="login">
        <div className="loginContainer">
          <h2>Вход в систему</h2>
          <form noValidate onSubmit={onSubmit}>
            <div className="loginEmail">
              <label>Логин(email)</label>
              <TextField
                size="small"
                className="email"
                variant="outlined"
                margin="normal"
                required
                id="email"
                name="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoFocus
              />
            </div>
            <div className="loginPassword">
              <label>Пароль</label>
              <TextField
                size="small"
                className="password"
                variant="outlined"
                margin="normal"
                required
                name="password"
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
              <span>{error}</span>
            </div>
            <div className="loginButtons">
              <Button
                fullWidth
                variant="contained"
                color="primary"
                id="btnBack"
              >
                Назад
              </Button>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                id="btnSubmit"
              >
                Войти
              </Button>
            </div>
            {error && (
              //  <label onClick={openForgotForm} className="forgot">
              //   Забыли пароль?
              //</label>
              <Link to={"/password/reset"} className="forgot">
                Забыли пароль?
              </Link>
            )}
            <div className="loginFooter">
              <p>
                Входя в систему, вы принимаете{" "}
                <Link to="/login">пользовательское соглашение</Link> и{" "}
                <Link to="/login">
                  политику обработки персональных
                  <br /> данных
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default compose(withApiService())(withRouter(Login));
